(function ($, w, u) {
    var instance = null,
        selector = null,
        defaults = {
            changeState: true,
            catalogCardSelector: '.j-catalog-card',
            useCache: true,
            skin: 'default'
        };

    var ModificationChange = function (selector, options) {
        this.options = $.extend(defaults, options);
        this.setSelector(selector);
    };
    ModificationChange.instances = [];
    ModificationChange.prototype = {
        setSelector : function (selector) {
            this.form = $(selector);
            this.init();
        },

        init : function () {
            this.trigger('onBeforeInit');
            this.action = this.form.attr('data-action');
            this.changedProp = this.form.find(':input:first').data('prop');
            this.initialCaller = null;
            this.initForm();
            this.initInputs();
            this.initHistory();

            this.trigger('onAfterInit');
        },

        blocks : [],

        initBlocks : function () {
            var self = this;
            this.blocks = [];
            $('[id^="mod-block-"]').each(function () {
                var me = $(this),
                    id = me.attr('id').substr('mod-block-'.length);

                self.blocks.push({
                    id : id,
                    obj : me
                });
            });
        },

        initForm : function () {
            var self = this;

            this.form.off('submit.ModificationChange').on('submit.ModificationChange', function () {
                return self.submit(self.options.changeState);
            });
        },

        submit : function (pushState, modification, changedProp) {
            var self = this,
                params = modification || self.getFormParams(),
                key = self.makeCacheKey(params, changedProp || self.changedProp),
                cache = self.readByKey(key);

            if (self.trigger('onBeforeSubmit') === false) {
                return false;
            }

            if (this.options.useCache && cache) {
                if (pushState) {
                    self.pushState({
                        modification: params,
                        changedProp: changedProp
                    }, cache.title, cache.link);
                }
                self.setHeadTitle(cache.title);
                self.appendHtml(cache.html);
                self.updateLang(cache.lang);

                return;
            }

            this.initBlocks();
            self.trigger('onBeforeAjax', self.changedProp, self.initialCaller);

            sendAjax(self.action + self.changedProp + '/', params, function (status, response) {
                self.trigger('onAfterAjax', self.changedProp);
                if (status === 'OK') {
                    if (pushState) {
                        self.pushState({
                          modification: self.getFormParams(),
                          changedProp: self.changedProp
                        }, response.title, response.link);
                    }

                    if (response.title) {
                        self.setHeadTitle(response.title);
                    }

                    self.appendHtml(response.html);

                    self.updateLang(response.lang);

                    if (self.options.useCache) {
                        if (self.getCacheLength() === 10) {
                            self.clearCache();
                        }

                        self.writeByKey(self.makeCacheKey(self.getFormParams(), self.changedProp), {
                            title: response.title,
                            link: response.link,
                            html:  response.html,
                            lang: response.lang
                        });
                    }

                    self.trigger('onAfterSubmit', status, response);
                } else {
                    self.trigger('onSubmitError', status, response);
                }
            });

            return false;
        },

        initInputs : function () {
            var self = this;
            self.form.find(':input').off('change.ModificationChange').on('change.ModificationChange', function (e, caller) {
                self.changedProp = $(this).data('prop');
                self.initialCaller = caller;

                self.submit(self.options.changeState);
            });
        },

        htmlCache: {},

        readByKey: function (key) {
            return this.htmlCache[key] ? this.htmlCache[key] : null;
        },

        writeByKey: function (key, value) {
            this.htmlCache[key] = value;
        },

        getCacheLength: function () {
            return Object.keys(this.htmlCache).length;
        },

        clearCache: function () {
            delete this.htmlCache[Object.keys(this.htmlCache)[0]];
        },

        makeCacheKey: function (paramsArray, changedProp) {
            return $.param(paramsArray) + '/' + changedProp;
        },

        getFormParams: function () {
            return this.form.serializeArray();
        },

        initHistory: function () {
            var self = this;

            if(!w.history.state) {
                var currentParams = this.getFormParams();
                this.replaceState({modification: currentParams});
            }

            if (w.history && w.history.pushState) {
                $(w).off('popstate.modificationChange').on('popstate.modificationChange', function (e) {
                    if (w.history.state && w.history.state.modification) {
                        self.submit(false, w.history.state.modification, w.history.state.changedProp);
                    }
                });
            }
        },

        pushState: function(state, title = '', url = '') {
            if (w.history && w.history.pushState) {
                w.history.pushState(state, title, url);
            }
        },

        replaceState: function(state, title = '', url = '') {
            if (w.history && w.history.replaceState) {
                w.history.replaceState(state, title, url);
            }
        },

        setHeadTitle : function (title) {
            $('head title').text(title);
        },

        appendHtml : function (data) {
            this.trigger('onBeforeAppendHtml');
            var blocks = [];
            if (data instanceof Array) {
                for (var i = 0, l = data.length; i < l; ++i) {
                    var name = data[i].name,
                        newName = data[i].newName,
                        content = data[i].content,
                        newBlock = $('[data-view-block="' + name + '"]');

                    newBlock.html(content);
                    if (newName) {
                        newBlock = newBlock.attr('data-view-block', newName);
                    }
                    blocks.push(newBlock);
                }
            } else if (this.blocks.length) {
                var newData = $(data);
                for (var i = this.blocks.length; --i >= 0; ) {
                    var block = this.blocks[i],
                        id = block.id,
                        obj = block.obj;

                    var newObj = newData.filter('#mod-block-' + id).length ? newData.filter('#mod-block-' + id) : newData.find('#mod-block-' + id);
                    obj.empty().html(newObj.html());
                    blocks.push(newObj);
                }
            } else {
                var catalogCard = this.form.parents(this.options.catalogCardSelector);
                catalogCard.html(data);
                blocks.push(catalogCard.children());
            }
            this.trigger('onAfterAppendHtml', blocks);
        },

        updateLang: function (lang) {
            if ( lang !== undefined) {
                $('[data-widget=lang_menu]').replaceWith(lang);
            }
        },

        loadModificationInfo: function (id, changedProp, value, callback) {
            var data = this.form.serializeArray();

            data.push({
                name: 'id',
                value: id
            }, {
                name: 'changedProp',
                value: changedProp
            }, {
                name: 'param[' + changedProp + ']',
                value: value
            });

            sendAjax(GLOBAL.URI_PREFIX + '_widget/modificationChange/loadModificationInfo', data, function (status, response) {
                if (typeof callback === 'function') {
                    callback(status, response);
                }
            });
        },

        loadModificationList: function (modelId, paramName, callback) {
            sendAjax(GLOBAL.URI_PREFIX + '_widget/modificationChange/loadModificationList', {
                'modelId': modelId,
                'paramName': paramName,
                'skin': this.options.skin
            }, function (status, response) {
                if (typeof callback === 'function') {
                    callback(status, response);
                }
            });
        }
    };
    $.extend(ModificationChange.prototype, TMEvents);
    $.extend(ModificationChange, TMEvents);
    ModificationChange.setSelector = function (value) {
        if (this.isInitialized()) {
            ModificationChange.getInstance().setSelector(value);
        }
        selector = value;
    };
    ModificationChange.getInstance = function () {
        if (this.instances.length === 0) {
            this.instances.push(this.createInstance(selector, defaults));
        }

        return this.instances[this.instances.length - 1];
    };
    ModificationChange.createInstance = function (selector, options) {
        var newInstance = new ModificationChange(selector, options);
        
        this.instances.push(newInstance);
        this.trigger('onCreateInstance', newInstance);

        return newInstance;
    };
    ModificationChange.isInitialized = function () {
        return this.instances.length !== 0;
    };
    ModificationChange.getInstances = function () {
        return this.instances;
    }

    w.ModificationChange = ModificationChange;

})(jQuery, window);